import { NgTemplateOutlet } from "@angular/common";
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewChild,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { ValidationRuleDirective } from "../../../../validation/validation-rule.directive";
import { InputComponent } from "../../../input/input.component";
import { GridBaseComponent } from "../grid-base/grid-base.component";

@Component({
    selector: "rask-grid-input",
    template: `
        <rask-input
            [raskRule]="rule"
            raskRuleDisplayType="Popover"
            [placeholder]="placeholder"
            class="cell grid"
            [(ngModel)]="presentationValue"
            [readonly]="true"
            [ngbPopover]="template"
            [disablePopover]="popoverDisabled"
            [openDelay]="300"
            [closeDelay]="300"
            triggers="mouseenter:mouseleave"
            container="body"
            popoverClass="line-wrapped-tooltip">
        </rask-input>
        <ng-template #template>
            {{ tooltipValue }}
            <ng-content></ng-content>
        </ng-template>

        <div #templateResult style="display: none">
            <ng-container *ngTemplateOutlet="template"></ng-container>
        </div>
    `,
    styleUrls: ["./grid-input.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputComponent,
        ValidationRuleDirective,
        FormsModule,
        NgbPopover,
        NgTemplateOutlet
    ]
})
export class GridInputComponent extends GridBaseComponent implements OnInit, AfterViewInit {
    popoverDisabled = false;
    presentationValue: any;
    @ViewChild("templateResult") templateResult;

    private readonly changeRef = inject(ChangeDetectorRef);

    ngAfterViewInit(): void {
        this.changeRef.detectChanges();
    }

    ngOnInit(): void {
        this.popoverDisabled = typeof this.tooltipValue !== "string";
        if(this.viewFormatter) {
            this.presentationValue = this.viewFormatter(this.value);
        } else {
            this.presentationValue = this.value;
        }
    }
}
